import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Select2OptionData } from 'ng-select2';
import { ToastrService } from 'ngx-toastr';
import { CreateResult } from '../../models/create-result';
import { ParticipantMappingViewModel } from '../../models/participant-mapping-view-model';
import { ParticipantViewModel } from '../../models/participant-view-model';
import { SinkNodeMappedFieldsViewModel } from '../../models/sinknode-mapped-fields-view-model';
import { AuthenticationService } from '../../services/authentication.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { ParticipantService } from '../../services/participant.service';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { Subject, Subscription } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SinkNodeMappingDialogComponent } from './sink-node-mapping-dialog/sink-node-mapping-dialog.component';
import { SinkNodeMappingConfigViewModel } from '../../models/sinknode-mapping-config-view-model';
import { ConfirmationDialogComponent } from '../../partials/confirmation-dialog/confirmation-dialog.component';
import { MerchantService } from '../../services/merchant.service';

@Component({
  selector: 'app-sink-node-mapping-view',
  templateUrl: './sink-node-mapping-view.component.html',
  styleUrls: ['./sink-node-mapping-view.component.scss']
})
export class SinkNodeMappingViewComponent implements OnInit {

  public selectedMappingId: string;

  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<boolean> = new Subject();
  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  private dataSubscription: Subscription;
  public participant: ParticipantViewModel;
  public sinkNodeMappedFields: SinkNodeMappedFieldsViewModel[] = [];
  public createResult: CreateResult;
  public canEdit: boolean;

  public sinkNodes: string[] = [];
  public selectedSinkNodes: string[] = [];

  public allMapDescriptions: SinkNodeMappingConfigViewModel[];
  public selectedMapDescriptions: SinkNodeMappingConfigViewModel[] = [];


  public sinkNodeParticipantMappingConfigs: ParticipantMappingViewModel[] = [];

  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };

  public get hasAvailableMapDescription(): boolean {
    if (!!this.allMapDescriptions) {
      return this.allMapDescriptions.filter(m => !this.selectedMapDescriptions.includes(m)).length !== 0;
    }
    return false;
  }

  public get hasAvailableSinkNodes(): boolean {
    if (!!this.sinkNodes) {
      return this.sinkNodes.filter(s => !this.selectedSinkNodes.includes(s)).length !== 0;
    }
    return false;
  }

  public mapDescriptionForId(id: number): SinkNodeMappingConfigViewModel {
    return this.allMapDescriptions.find(d => d.id == id);
  }

  constructor(private _participantService: ParticipantService,
    private _authenticationService: AuthenticationService,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService,
    private _route: ActivatedRoute,
    private _modalService: NgbModal,
    private _merchantService: MerchantService) {
  }

  public async ngOnInit(): Promise<void> {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    const params = this._route.snapshot.params;
    await this.refresh(params.id);
    this.dtTrigger.next();
    this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditParticipantConfiguration], []);
  }

  public ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  public async refresh(id: number): Promise<void> {
    debugger;
    this.participant = await this._participantService.GetParticipant(id);
    this.allMapDescriptions = await this._participantService.GetDefaultMapDescriptions();
    this.sinkNodeParticipantMappingConfigs = await this._participantService.GetParticipantMappingSinkNodes(this.participant.id);
    //this.sinkNodes = (await this._participantService.GetAvailableSinkNodes(this.participant.id)).map(s => s.node);
    this.sinkNodes = (await this._participantService.GetSinkNodes()).map(s => s.node);
    this.initSelected();
  }

  public initSelected() {
    this.selectedSinkNodes = this.sinkNodeParticipantMappingConfigs.map(s => s.sinknode);
    this.selectedMapDescriptions = this.sinkNodeParticipantMappingConfigs
      .filter(s => this.allMapDescriptions.filter(m => m.id === s.mappingId))
      .map(s => this.allMapDescriptions.find(m => s.mappingId == m.id));
  }

  rerenderTable(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  public async save(): Promise<void> {
    debugger;
    if (!this.canEdit) {
      this._toastService.error('You do not have the required permissions to perform this action.', 'Error');
    } else {
      await this._participantService.DeleteSinkNode(this.participant.id);

      if (this.sinkNodeParticipantMappingConfigs.length == 0) {

        this._toastService.success('Updated.', 'Success');
      } else {
        this.createResult = await this._participantService.UpdateSinkNodes(this.sinkNodeParticipantMappingConfigs);
        if (this.createResult.success) {
          this._toastService.success(this.createResult.message, 'Success');
        } else {
          this._toastService.error(this.createResult.message, 'Error');
        }
      }
    }
  }

  public async openEditDialog(mappedField: ParticipantMappingViewModel): Promise<void> {
    const modalRef = this._modalService.open(SinkNodeMappingDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    modalRef.componentInstance.mappedField = mappedField;
    modalRef.componentInstance.sinkNodes = this.sinkNodes;
    modalRef.componentInstance.mapDescriptions = this.allMapDescriptions;
    modalRef.componentInstance.selectedSinkNodes = this.sinkNodeParticipantMappingConfigs;
    modalRef.componentInstance.selectedMapDescriptions = this.selectedMapDescriptions;
    const result: { option: string, data: any } = await modalRef.result;
    if (result?.option === 'create') {
      await this.create(result.data);
    }
    if (result?.option === 'update') {
      await this.update(result.data);
    }
    if (result?.option === 'delete') {
      await this.openDeleteConfirmationDialog(result.data);
    }
  }

  public async showCreateDialog() {
    await this.openEditDialog({
      mappingId: parseInt(this.selectedMappingId, 10),
      participantId: this.participant.id
    });
  }

  public async openDeleteConfirmDialog(mappedField: ParticipantMappingViewModel) {

    const count = await this._merchantService.GetSinkNodeMappedFieldsCountByParticipantIdAndSinkNode(mappedField.participantId, mappedField.sinknode);

    if (count > 0) {
      this.openUsedDeleteFailureConfirmationDialog(count);
    }
    else {
     this.openDeleteConfirmationDialog(mappedField);
    }
  }

  public async openUsedDeleteFailureConfirmationDialog(count: number) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.acceptButtonText = "OK"
    dialogRef.componentInstance.title = "Sink node config cannot be removed"
    dialogRef.componentInstance.message = "This Sink node config is currently in use and cannot be deleted.<br/><br/><b>" + count + " Merchants are using this sink node config.</b>"
  }


  public async openDeleteConfirmationDialog(mappedField: ParticipantMappingViewModel) {

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Yes';
    dialogRef.componentInstance.cancelButtonText = 'No'
    dialogRef.componentInstance.title = 'Sink Node Mapping Removal'
    dialogRef.componentInstance.message = 'Are you sure you want to delete the selected sink node mapping?'

    const result = await dialogRef.result;
    if (result) {
      await this.delete(mappedField);
    }
  }

  public async delete(mappedField: ParticipantMappingViewModel): Promise<void> {
    const index = this.sinkNodeParticipantMappingConfigs.indexOf(mappedField);
    if (index > -1) {
      this.sinkNodeParticipantMappingConfigs.splice(index, 1);
      this.rerenderTable();
    }
    await this.save();
    this.initSelected();
  }

  public async create(mappedField: ParticipantMappingViewModel): Promise<void> {
    this.sinkNodeParticipantMappingConfigs.push(mappedField);
    await this.save();
    this.sinkNodeParticipantMappingConfigs = await this._participantService.GetParticipantMappingSinkNodes(this.participant.id);
    this.rerenderTable();
    this.initSelected();
  }

  public async update(mappedField: ParticipantMappingViewModel): Promise<void> {
    const index = this.sinkNodeParticipantMappingConfigs.findIndex(s => s.id === mappedField.id);
    if (index > -1) {
      this.sinkNodeParticipantMappingConfigs[index] = mappedField;
      this.rerenderTable();
    }
    await this.save();
    this.initSelected();
  }

  public showToast(result: CreateResult) {
    if (!!result.success) {
      this._toastService.success(result.message, 'Success');
    } else if (result.message) {
      this._toastService.error(result.message, 'Error');
    } else {
      this._toastService.error('Unknown Error Occured', 'Error');
    }
  }
}
